export default "__VITE_ASSET__1018f255__"